// Copyright 2022, Imprivata, Inc.  All rights reserved.
import { Card, Flex, Skeleton } from 'antd';
import DateOfBirth from './DateOfBirth';
import Name from './Name';
export interface DemographicsCardProps extends React.HTMLAttributes<HTMLDivElement> {
  givenName?: string;
  surname?: string;
  dateOfBirth?: string;
  mrn?: string;
  isLoading?: boolean;
}
const DemographicsCard = (props: DemographicsCardProps) => {
  return (
    <Card className="w-100 bg-gray justify-center" style={props.style} data-testid="demographics-card">
      {props.isLoading && (
        <Skeleton paragraph={{ rows: 2 }} title={{ width: '100%' }} active data-testid="demographics-skeleton" />
      )}
      {!props.isLoading && (
        <Flex gap={30} vertical>
          <Name givenName={props.givenName} surname={props.surname} data-testid="demographics-name" />
          <Flex gap={13} vertical>
            <DateOfBirth dateOfBirth={props.dateOfBirth} data-testid="demographics-dob" />
          </Flex>
        </Flex>
      )}
    </Card>
  );
};
export default DemographicsCard;
